import { getSpecialCalculationCost } from '@/services/admin/special-calculation-costs';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

export const useSpecialCalculationCostDetail = (id: number) => {
  const { site } = useParams<{ site: string }>();
  const currentSite = site ?? 'medix';

  return useQuery({
    queryKey: ['specialCalculationCostDetail', currentSite, id],
    queryFn: () => getSpecialCalculationCost(currentSite, id),
    select: res => res.data,
    enabled: !!id,
  });
};
